/**
 * Spotlight Media Block — inline video playback
 *
 * Clicking the poster swaps it for an autoplaying iframe (YouTube/Vimeo) or
 * <video> element (self-hosted). The poster fades out via CSS.
 */

const getYoutubeId = (url) => {
    try {
        const u = new URL(url);
        const host = u.hostname.toLowerCase();

        if (host.includes('youtu.be')) {
            return u.pathname.replace(/^\//, '').split('/')[0] || '';
        }

        if (host.includes('youtube.com')) {
            if (u.searchParams.get('v')) return u.searchParams.get('v');
            const m = u.pathname.match(/\/(embed|shorts)\/([^/?]+)/);
            if (m) return m[2];
        }
    } catch (e) {
        // fallthrough
    }
    return '';
};

const getVimeoId = (url) => {
    try {
        const u = new URL(url);
        if (!u.hostname.toLowerCase().includes('vimeo.com')) return '';
        const m = u.pathname.match(/\/(\d+)/);
        return m ? m[1] : '';
    } catch (e) {
        return '';
    }
};

const buildEmbed = (source, url) => {
    if (source === 'self-hosted') {
        const video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = 'auto';
        return video;
    }

    const ytId = getYoutubeId(url);
    if (ytId) {
        const iframe = document.createElement('iframe');
        iframe.src =
            `https://www.youtube.com/embed/${encodeURIComponent(ytId)}` +
            `?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
        iframe.title = 'Video player';
        iframe.allow =
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        return iframe;
    }

    const vimeoId = getVimeoId(url);
    if (vimeoId) {
        const iframe = document.createElement('iframe');
        iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(vimeoId)}?autoplay=1`;
        iframe.title = 'Video player';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        return iframe;
    }

    return null;
};

const initInlineTrigger = (trigger) => {
    if (trigger.dataset.spotlightMediaInlineBound === 'true') return;
    trigger.dataset.spotlightMediaInlineBound = 'true';

    const frame = trigger.querySelector('[data-spotlight-media-inline-frame]');
    if (!frame) return;

    trigger.addEventListener('click', (event) => {
        if (trigger.classList.contains('is-playing')) return;
        event.preventDefault();

        const source = trigger.dataset.videoSource || 'youtube';
        const url = trigger.dataset.videoUrl || '';
        if (!url) return;

        const embed = buildEmbed(source, url);
        if (!embed) return;

        frame.innerHTML = '';
        frame.appendChild(embed);
        trigger.classList.add('is-playing');
    });
};

const initBlock = (block) => {
    block
        .querySelectorAll('[data-spotlight-media-inline]')
        .forEach(initInlineTrigger);
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.spotlight-media').forEach(initBlock);
});

// Re-initialize in the block editor preview
document.addEventListener('blockEditorInit', (e) => {
    const block = e.detail && e.detail.block;
    if (block) {
        block.querySelectorAll('.spotlight-media').forEach(initBlock);
    }
});
